/** @format */

module.exports = require("./igaming");



// WEBPACK FOOTER //
// ./src/partners/variant-flows/MGA.js